'use client';
import { useLatestRef } from '../useLatestRef/useLatestRef.js';
import { useIsomorphicEffect } from '../useIsomorphicEffect/useIsomorphicEffect.js';

var useLayoutListener = function(target, type, listener) {
    var latestListener = useLatestRef(listener);
    useIsomorphicEffect(function() {
        var handler = function(event) {
            return latestListener.current(event);
        };
        if (!target) {
            return;
        }
        target.addEventListener(type, handler);
        return function() {
            return target.removeEventListener(type, handler);
        };
    }, []);
};

export { useLayoutListener };
